import mapActions from './mapActions';

export default mapActions('work_operations');
